import { morph } from '@theme/morph';
import { StandardEvents } from '@shopify/events';

/**
 * MARKD waitlist block.
 * Re-renders itself from the section HTML whenever the shopper picks a different variant,
 * so the waitlist form only shows for sold-out variants.
 */
class MarkdWaitlist extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');
    this.section?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    this.section?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  /** @param {any} event */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;
        if (!detail.newProduct && detail.productId && detail.productId !== this.dataset.productId) return;

        const next = detail.html.querySelector(`markd-waitlist[data-block-id="${this.dataset.blockId}"]`);
        if (!next) return;

        // Keep whatever the shopper already typed.
        const email = this.querySelector('input[type="email"]')?.value;
        morph(this, next, { childrenOnly: true });
        this.toggleAttribute('hidden', next.hasAttribute('hidden'));
        const input = this.querySelector('input[type="email"]');
        if (input && email) input.value = email;
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[markd-waitlist]', error);
      });
  };
}

if (!customElements.get('markd-waitlist')) {
  customElements.define('markd-waitlist', MarkdWaitlist);
}
